import React from "react"; 
import SignUpForm from "../../components/Auth/SignUpForm";

const SignUp = () => {
  return (
    <>
      <SignUpForm />
    </>
  );
};

export default SignUp;
